import type { FC } from 'react';
import React from 'react';
import { StyledLinearGradient, StyledSvg } from './AnimatedBorder.styles';
import type { AnimatedBorderProps } from './AnimatedBorder.types';

export const AnimatedBorder: FC<AnimatedBorderProps> = props => {
  const { isVisibile, inset, padding, borderRadius, borderWidth, height } = props;

  // The <defs> below animate `stop-color` on five <stop>s forever. That is an SVG paint
  // property, so each frame forces a style recalc — for every instance mounted, hovered or
  // not. The editor preview mounts ~54 of these, so a completely idle editor ran 279
  // animations and burned ~0.8s of style recalc every 15s. Rendering nothing until the
  // border is shown keeps the animation off entirely.
  if (!isVisibile) {
    return null;
  }

  return (
    <>
      <svg
        style={{ position: 'absolute' }}
        width="0"
        height="0"
      >
        <defs>
          <StyledLinearGradient
            id="grad"
            x1="0"
            x2="1"
            y1="0"
            y2="1"
          >
            <stop
              offset="0%"
              id="stop1"
              stopColor="color(display-p3 0.28 0 1 / 1)"
            />
            <stop
              offset="25%"
              id="stop2"
              stopColor="color(display-p3 0.28 0 1 / 1)"
            />
            <stop
              offset="50%"
              id="stop3"
              stopColor="color(display-p3 0.28 0 1 / 1)"
            />
            <stop
              offset="75%"
              id="stop4"
              stopColor="color(display-p3 0.28 0 1 / 1)"
            />
            <stop
              offset="100%"
              id="stop5"
              stopColor="color(display-p3 0.28 0 1 / 1)"
            />
          </StyledLinearGradient>
        </defs>

        <symbol
          id="border"
          overflow="visible"
        >
          <rect
            width="100%"
            height="100%"
            rx={borderRadius}
            ry={borderRadius}
          />
        </symbol>
      </svg>

      <StyledSvg
        inset={inset}
        padding={padding}
        borderWidth={borderWidth}
        height={height}
      >
        <use href="#border" />
      </StyledSvg>
    </>
  );
};

AnimatedBorder.displayName = 'AnimatedBorder';
